import type { IconBaseProps } from "./IconBase";
import IconBase from "./IconBase";

export const ForwardIcon = (props: IconBaseProps) => {
  return (
    <IconBase {...props}>
      <path d="M9 17L15 12L9 7V17Z" fill="currentColor" />
    </IconBase>
  );
};

export default ForwardIcon;
